import React, { useEffect, useState } from 'react';
import { Alert, View, Text, Platform } from 'react-native'
import WebView from 'react-native-webview';
import { WebView as WWebView } from 'react-native-web-webview';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { oStyles } from '../olonkho-styles';
import { OPanelButton, OControlButton, OPageNumber } from '../olonkho-fw';
import { Pages } from '../olonkho-page-info';
import { WebPages } from '../web-pages';
import { Descriptions } from '../olonkho-descriptions';
import AudioPlayer from '../player';
import { Overlay, Input, Button } from 'react-native-elements';

export default function Viewer({ route, navigation }) {
    const { line } = route.params;
    const [pageNumber, setPageNumber] = useState(0);
    const [isPlayerEnabled, setPlayerEnabled] = useState(false);
    const [showDialog, setShowDialog] = useState(false);
    const [showDescription, setShowDescription] = useState(false);
    const [descritionId, setDescriptionId] = useState(0);
    const [dialogValue, setDialogValue] = useState("");
    const [isTraditional, setIsTraditional] = useState(false);
    const [isLoaded, setIsLoaded] = useState(false);

    const storeData = async (value) => {
        try {
            await AsyncStorage.setItem('@page_number', value);
        } catch (exception) {
            return;
        }
    }

    const getData = async () => {
        try {
            const value = await AsyncStorage.getItem('@page_number');
            if(value) {
                setPageNumber(parseInt(value));
            }
        } catch(exception) {
            return;
        }
    }

    useEffect(() => {
        navigation.addListener('focus', () => {
            if (line == -1) {
                getData();
                setIsLoaded(true);
            }
        })
    }, [navigation]);
    
    useEffect(() => {
        if (line != -1) {
            let page = Math.floor(line / 30);
            if (page >=0 && page < Pages.length) {
                setPageNumber(page);
            }
        }
    }, [line]);

    useEffect(() => {
        if (isLoaded && line == -1) {
            storeData(pageNumber.toString()); 
        }
    }, [pageNumber]);

    return (
        <View style={oStyles.viewer_container}>
            <AudioPlayer 
                title={ Pages[pageNumber].title } 
                source={ isTraditional ? Pages[pageNumber].traditional : Pages[pageNumber].sound } 
                isEnabled={ isPlayerEnabled } 
                onClose={ () => { setPlayerEnabled(false); }}
                onEnd={ () => {
                    if (pageNumber < Pages.length - 1) {
                        setPageNumber(pageNumber + 1);
                    }
                    else {
                        setPlayerEnabled(false);
                    }
                } }
            />
            <View style={ oStyles.control_panel }>
                <OPanelButton title="Традиционное исполнение" onPress={ () => {
                    setIsTraditional(true);
                    setPlayerEnabled(true);
                } }/>
                <OPanelButton title="Выразительное чтение" onPress={ () => {
                    setIsTraditional(false);
                    setPlayerEnabled(true);
                } }/>
            </View>
            { (Platform.OS === 'ios' || Platform.OS === 'android') && 
                <WebView 
                    source={{ html: WebPages[pageNumber] }}
                    onMessage={(event) => {
                        try {
                            let index = parseInt(event.nativeEvent.data);
                            if (index < Descriptions.length) {
                                Alert.alert(Descriptions[index].title, Descriptions[index].text);
                            }
                        }
                        catch(exception) {
                            console.log(exception);
                        }
                }}
                />
            }
            { Platform.OS === 'web' && 
                <WWebView 
                    source={{ html: WebPages[pageNumber] }}
                    onMessage={(event) => {
                        try {
                            let index = parseInt(event.nativeEvent.data);
                            if (index < Descriptions.length) {
                                setDescriptionId(index);
                                setShowDescription(true);
                            }
                        }
                        catch(exception) {
                            console.log(exception);
                        }
                    }}
                />
            }
            <View style={ oStyles.control_panel }>
                <OControlButton title="<<" onPress={ 
                    () => {
                        if (pageNumber > 0) {
                            setPageNumber(pageNumber - 1);
                        }
                    }
                }/>
                <OPageNumber number={ (pageNumber + 1).toString() } onPress={ () => {
                    setShowDialog(true);
                } }/>
                <OControlButton title=">>" onPress={
                    () => {
                        if (pageNumber < Pages.length - 1) {
                            setPageNumber(pageNumber + 1);
                        }
                    }
                }/>
            </View>
            <Overlay isVisible={showDialog} onBackdropPress={() => { setShowDialog(false) }}>
                <Text style={ { marginTop: 20, marginLeft: 40, marginRight: 40, marginBottom: 20 } }>Введите номер страницы:</Text>
                <View>
                    <Input keyboardType='numeric' textAlign='center' onChangeText={ (text) => { setDialogValue(text); }} value={ dialogValue }/>
                </View>
                <View style={ { flexDirection: 'row', justifyContent: 'center' } }>
                    <View style={ { flex: 1 } }>
                        <Button title="Отмена" type="clear" onPress={ () => {
                            setDialogValue("");
                            setShowDialog(false);
                        } }/>
                    </View>
                    <View style={ { flex: 1 } }>
                        <Button title="Перейти" type="clear" onPress={ () => {
                            try {
                                let num = parseInt(dialogValue);
                                if (num) {
                                    if (num < 1) {
                                        num = 1;
                                    }
                                    if (num > Pages.length) {
                                        num = Pages.length;
                                    }
                                    setPageNumber(num - 1);
                                }
                            }
                            catch(exception) {
                                console.log(exception);
                            }
                            setDialogValue("");
                            setShowDialog(false);
                        } }/>
                    </View>
                </View>
            </Overlay>
            <Overlay isVisible={ showDescription } onBackdropPress={() => { setShowDescription(false); }}>
                <Text style={ {
                    fontWeight: 'bold',
                    marginHorizontal: 20,
                    marginTop: 20
                } }>{ Descriptions[descritionId].title }</Text>
                <Text style={ {
                    marginTop: 10,
                    marginBottom: 20,
                    marginHorizontal: 20
                } }>{ Descriptions[descritionId].text }</Text>
                <Button type="clear" style={ { width: 100, alignSelf: 'flex-end' } } title="OK" onPress={ () => {
                    setShowDescription(false);
                } }/>
            </Overlay>
        </View>
    );
}